module.exports = __webpack_public_path__ + "media/下载测试版APP指引（iOS-test）.3c722b9.mp4";


//////////////////
// WEBPACK FOOTER
// ./src/assets/video/下载测试版APP指引（iOS-test）.mp4
// module id = nsZY
// module chunks = 3